import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [


  {
    name: 'Accueil',
    url: '/dashboard',
    icon: 'icon-home',
  },
  /*
  {
    name: 'Dashboad',
    url: '#',
    icon: 'icon-grid',
    badge: {
      variant: 'secondary',
      text: 'En cours'
    },
    attributes: { disabled: true },
  },
  */
  {
    name: 'Résumé du marché',
    url: '/marche',
    icon: 'icon-pie-chart',
  },
  {
    title: true,
    name: 'DASHBOARD DE SUIVI'
  },
  {
    name: 'Suivi des Actions',
    url: '/table',
    icon: 'icon-list',
  },
  // {
  //   name: 'Suivi des OPCVMs',
  //   url: '/opcvmtable',
  //   icon: 'icon-list',
  // },
  {
    name: 'Suivi des OPCVM',
    url: '/opcvmtableGroupe',
    icon: 'icon-list',
  },
 
  // {
  //   title: true,
  //   name: 'PORTEFEUILLE',
  // },
  // {
  //   name: 'Mon portefeuille',
  //   url: '/dashbordcompte',
  //   icon: 'icon-wallet',
  // },
  {
    title: true,
    name: 'CONSEILLER INTELLIGENT',
  
  },
  
  {
    name: 'Avis des 6 Conseillers',
    url: '/dashbordModels',
    icon: 'icon-star',
  },
  {
    name: "Analyse Fondamentale",
    url: '/dashbordModels_1',
    icon: 'icon-star',
  },

  {
    name: 'Avis  Tech & Fond',
    url: '/Tech_Fond',
    icon: 'icon-star',
  },
  {
    title: true,
    name: 'ARBITRAGE ENTRE LES CONSEILLERS'
  },


  {
    name: 'Meilleurs conseils du jour',
    url: '/dashbordalgog',
    icon: 'icon-star',
  },  
  // {
  //   name: 'TOP 3 des meilleurs conseils du jour',
  //   url: '/dashbordalgogtop',
  //   icon: 'icon-star',
  // },

  {
    name: 'Historique des meilleurs conseils',
    url: '/dashbordPredictions',
    icon: 'icon-star',
  },
  {
    name: "Historique d'analyse fondamentale",
    url: '/Historique_Fondamentale',
    icon: 'icon-star',
  },

  {
    name: 'Historique Tech & Fond',
    url: '/Historique_Tech_Fond',
    icon: 'icon-star',
  },
  // {
  //   name: 'Historique_Prediction',
  //   url: '/Histo_prediction',
  //   icon: 'icon-star',
  // },

  
  // {
  //   title: true,
  //   name: 'Paramètres'
  // },
  /*
  {
    name: 'Préférences',
    url: '#',
    icon: 'icon-settings',
    badge: {
      variant: 'secondary',
      text: 'En cours'
    },
    attributes: { disabled: true },
  },
  */
  // {
  //   name: 'Utilisateurs',
  //   url: '/users',
  //   icon: 'icon-people',
  // },

  // {
  //   name: 'test1',
  //   url: '/info',
  //   icon: 'icon-people',
  // }
];
